/**
 * Authors: mariushirjanu
 * Created: 05/08/2021
 */
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { UntypedFormGroup } from '@angular/forms';

export const EVENT_SAVE_BP_INVOICE_TEMPLATE:string = 'saveBPInvoiceTemplate';
export const EVENT_CANCEL_BP_INVOICE_TEMPLATE:string = 'cancelBPInvoiceTemplate';
export const EVENT_EDIT_BP_INVOICE_TEMPLATE:string = 'editBPInvoiceTemplate';

@Injectable()
export class InvoiceTemplatesService {
  private _editing:boolean = false;
  private _onEditingChangeSubject:Subject<boolean> = new Subject<boolean>();
  private _form:UntypedFormGroup;
  private _onFormChangeSubject:Subject<UntypedFormGroup> = new Subject<UntypedFormGroup>();

  public onEditingChange:Observable<boolean> = this._onEditingChangeSubject.asObservable();
  public onFormChange:Observable<UntypedFormGroup> = this._onFormChangeSubject.asObservable();

  public get editing():boolean {
    return this._editing;
  }

  public set editing(editing:boolean) {
    this._editing = editing;
    this._onEditingChangeSubject.next(editing);
  }

  public get form():UntypedFormGroup {
    return this._form;
  }

  public set form(form:UntypedFormGroup) {
    this._form = form;
    this._onFormChangeSubject.next(form);
  }
}